import styled from 'styled-components'
import styles from './styles'

const StyledButton = styled.button`
  /* stylelint-disable */
  ${styles};
`

export default StyledButton
